import { Agent } from "./Agent";
import { Gender } from "./Gender";

export type Person = Agent & {
    Avatar: string,
    FirstName: string,
    LastName: string,
    MiddleName: string,
    Gender: Gender,
    IdentityData: string,
    BirthDate: Date | null,
    Phone: string,
    Skype: string,
    Telegram: string,
    Email: string,
    Inn: string,
}

export const getPersonInitials = (person: Person) => {
    return `${person.LastName ? person.LastName[0] : ''}${person.FirstName ? person.FirstName[0] : ''}`;
}